// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8a48a4e8","455":"ab52e8c8","977":"9096a4be"}[chunkId] + ".chunk.js";
};